/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Tue Jan 12 2021 09:29:57 GMT+0100 (GMT+01:00)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const API_URL = API_URLS.THIRD_PARTY;
let URL_: string;
URL_ = `${API_URL}/api/third-party`;


// /**
//  * @tags Parameters Controller
//  * @summary
//  */
// export function getApiVersion() {
//   return request.get<string>(
//     `${API_URL}/api/version`
//   );
// }

// async function getConfiguration() {
//     const version = await getApiVersion();
    
    
//     const configuration = await request.get(URL_ );
//     return configuration;

// }
export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface SIPayBeneficiaryResponse {
  tpbklist: Array<TpBankAccount>;
  tpid: number;
  tpname: string;
  tpparentcompanyid: number;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
}

export interface ThirdPartyRequest {
  additionalInfo: tpAdditionalInfoRequest;
  address: tpAddressRequest;
  bankAccount: tpBankAccountRequest;
  contact: tpContactRequest;
  generalData: tpGeneralDataRequest;
  income?: tpIncomeRequest;
  role?: tpRoleRequest;
  spouse?: tpSpouseRequest;
}

export interface ViewEntityAddAttributeResponse {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attbooleanvalue: boolean;
  attcode: string;
  attlabel?: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  colspan: number;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entityid: number;
  entitytype: string;
  maxvalue: string;
  minvalue: string;
  parcode: string;
  prcode: string;
  style: string;
}

export interface TPAuthorizationDetailRulesResponse{
  rulid: number;
  authdetailid: number;
  tpidbeneficiary: number;
  authmonth: number;
  authamount: number;
  authtolerance: number;
  beneficiaryname: string;
  beneficiaryreference: string;
}

export interface TPAuthorizationDetailRulesRequest{
  rulid: number;
  authdetailid: number;
  tpidbeneficiary: number;
  authmonth: number;
  authamount: number;
  authtolerance: number;
  beneficiaryname: string;
  beneficiaryreference: string;
}

export interface ThirdPartyResponse {
  additionalInfo: tpAdditionalInfoResponse;
  address: tpAddressResponse;
  bankAccount: tpBankAccountResponse;
  contact: tpContactResponse;
  correspondent: tpCorrespondentResponse;
  generalData: tpGeneralDataResponse;
  income: tpIncomeResponse;
  role: tpRoleResponse;
  spouse: tpSpouseResponse;
  status: tpStatusResponse;
  entityAddAttributList: Array<ViewEntityAddAttributeResponse>;
}

export interface TpList {
  tagroles: string;
  tpfiscalid: string;
  tpid: number;
  tpidentitycardid: string;
  tpmainadrcity: string;
  tpmainadrstreet1: string;
  tpname: string;
  tpreference: string;
  tpstatus: string;
  tptype: string;
  parentname: string;
  parentreference: string;
  parentid: number;
  currcode:string;
}

export interface tpAdditionalInfoRequest {
  tpdescription: string;
  tpfree1: string;
  tpfree2: string;
  tpfree3: string;
  tpfree4: string;
  tpfree5: string;
  tpparentcompanyid: number;
  tpparentcompanyname: string;
}

export interface tpAdditionalInfoResponse {
  tpdescription: string;
  tpfree1: string;
  tpfree2: string;
  tpfree3: string;
  tpfree4: string;
  tpfree5: string;
  tpparentcompanyid: number;
  tpparentcompanyname: string;
}

export interface tpAddressRequest {
  tpmainadrcity: string;
  tpmainadrcountry: string;
  tpmainadrregion: string;
  tpmainadrregionglobale: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
  tpsecadrcity: string;
  tpsecadrcountry: string;
  tpsecadrregion: string;
  tpsecadrstreet1: string;
  tpsecadrstreet2: string;
  tpsecadrzipcode: string;
}

export interface tpAddressResponse {
  tpmainadrcity: string;
  tpmainadrcitylabel: string;
  tpmainadrcountry: string;
  tpmainadrregion: string;
  tpmainadrregionglobale: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
  tpsecadrcity: string;
  tpsecadrcountry: string;
  tpsecadrregion: string;
  tpsecadrstreet1: string;
  tpsecadrstreet2: string;
  tpsecadrzipcode: string;
}

export interface tpBankAccountRequest {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode: string;
  bktype: string;
  countcode: string;
  currcode: string;
  tpbankname: string;
  tpbic: string;
  tpbkid: number;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
}

export interface tpBankAccountResponse {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode: string;
  bktype: string;
  countcode: string;
  tpbankname: string;
  tpbic: string;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpbkid: number;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
}

export interface tpContactRequest {
  tpcontactname1: string;
  tpcontactname2: string;
  tpcontactposition1: string;
  tpcontactposition2: string;
  tpemail1: string;
  tpemail2: string;
  tptel1: string;
  tptel2: string;
  tptelmobile1: string;
  tptelmobile2: string;
}

export interface tpContactResponse {
  tpcontactname1: string;
  tpcontactname2: string;
  tpcontactposition1: string;
  tpcontactposition2: string;
  tpemail1: string;
  tpemail2: string;
  tptel1: string;
  tptel2: string;
  tptelmobile1: string;
  tptelmobile2: string;
}

export interface tpCorrespondentResponse {
  tpbouserdate: string;
  tpbouserid: number;
  tpbousername: string;
  tplpuserdate: string;
  tplpuserid: number;
  tplpusername: string;
  tprecuserdate: string;
  tprecuserid: number;
  tprecusername: string;
  tpriskuserdate: string;
  tpriskuserid: number;
  tpriskusername: string;
  tpsaleuserdate: string;
  tpsaleuserid: number;
  tpsaleusername: string;
}

export interface tpGeneralDataRequest {
  currcode: string;
  tpflagvatexemption: boolean;
  tpvatexemtionenddate: string;
  tpbrokerid: number;
  tporigin: string;
  tpspecialtag: string;
  tpcapital: string;
  tpcapitalholding: number;
  tpkycstatus: string;
  tppoliticallyexposedperson: boolean;
  tpantimoneylaunder: boolean;
  countcode: string;
  lancode: string;
  tpactivity: string;
  tpbirthcity: string;
  tpbirthcountry: string;
  tpbirthdate: string;
  tpbranchid: number;
  tpcompanycreationdate: string;
  tpfiscalcity: string;
  tpfiscalid: string;
  tpgender: string;
  tpid: number;
  tpidentitycardid: string;
  tpidentitycardtype: string;
  tplegalform: string;
  tpmaidenname: string;
  tpmanagername: string;
  tpmanagerposition: string;
  tpmaritalstatus: string;
  tpmarketingname: string;
  tpmiddlename: string;
  tpname: string;
  tpnbofchildren: number;
  tpprofession: string;
  tpsalutationcode: string;
  tpsurname: string;
  tptaxid: string;
  tptype: string;
  tpworkingctdate: string;
  tpworkingcttype: string;
  tpparentcompanyid: number;
  last_action?: number;
  tpflagresident: boolean;
  tpcategory: string;
  tpcompanysize: string;
  tprevenue: string;
  tprevenuereferenceyear: string;
  tpidentitycardcountry: string;
  tpidentitycardexpirationdate: string;
  tpactivitysector: string;
  tptradingid: number;
  tpcompanyid: number;
}

export interface tpGeneralDataResponse {
  currcode: string;
  tpflagvatexemption: boolean;
  tpvatexemtionenddate: string;
  tpbrokerid: number;
  tporigin: string;
  tpspecialtag: string;
  tpparentcompanyname: string;
  tpparentcompanyidreference: string;
  tpparentcompanyidname: string;
  tpparentcompanyid: number;
  tpcapital: string;
  tpcapitalholding: number;
  tpkycstatus: string;
  tpkycstatuslabel: string;
  tppoliticallyexposedperson: boolean;
  tpantimoneylaunder: boolean;
  tpkycdate: string;
  countcode: string;
  lancode: string;
  mgid: number;
  tpactivity: string;
  tpactivitylabel: string;
  tpbirthcity: string;
  tpbirthcountry: string;
  tpbirthdate: string;
  tpbranchid: number;
  tpcompanycreationdate: string;
  tpfiscalcity: string;
  tpfiscalid: string;
  tpgender: string;
  tpid: number;
  tpidentitycardid: string;
  tpidentitycardtype: string;
  tplegalform: string;
  tpmaidenname: string;
  tpmanagername: string;
  tpmanagerposition: string;
  tpmaritalstatus: string;
  tpmarketingname: string;
  tpmiddlename: string;
  tpname: string;
  tpnbofchildren: number;
  tpprofession: string;
  tpreference: string;
  tpsalutationcode: string;
  tpstatus: string;
  tpstatuslabel: string;
  tpstatusdate: string;
  tpsurname: string;
  tptaxid: string;
  tptype: string;
  tptypelabel: string;
  tpworkingctdate: string;
  tpworkingcttype: string;
  last_action: number;
  tpflagresident: boolean;
  tpcategory: string;
  tpcompanysize: string;
  tprevenue: string;
  tprevenuereferenceyear: string;
  tpidentitycardcountry: string;
  tpidentitycardexpirationdate: string;
  tpactivitysector: string;
  tpclass: string;
  tpclassdate: string;
  tpclasslabel: string;
  tptradingid: number;
  tpcompanyid: number;
}

export interface tpIncomeRequest {
  tpemloyertel: string;
  tpemployer: string;
  tpemployeraddress: string;
  tpfamilybenefits: number;
  tpmonthlyincome: number;
  tpotherloan: number;
  tpothersexpense: number;
  tpothersincome: number;
}

export interface tpIncomeResponse {
  tpemloyertel: string;
  tpemployer: string;
  tpemployeraddress: string;
  tpfamilybenefits: number;
  tpmonthlyincome: number;
  tpotherloan: number;
  tpothersexpense: number;
  tpothersincome: number;
}

export interface tpRoleRequest {
  tpreminderfeesformula: string;
  tpblockreminderfeesinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tprejectionfeesformula: string;
  tpblocklateinterestinvoicing: boolean;
  tplateinterestformula: string;
  tpflagclient: boolean;
  tpflagguarantor: boolean;
  tpflagsupplier: boolean;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tproleother: string;
}

export interface tpRoleResponse {
  tpreminderfeesformula: string;
  tpblockreminderfeesinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tprejectionfeesformula: string;
  tpblocklateinterestinvoicing: boolean;
  tplateinterestformula: string;
  tpflagclient: boolean;
  tpflagguarantor: boolean;
  tpflagsupplier: boolean;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeinlabel: string;
  tppaymodeout: string;
  tproleother: string;
}

export interface tpSpouseRequest {
  spbirthcity: string;
  spbirthcountry: string;
  spbirthdate: string;
  spemloyertel: string;
  spemployer: string;
  spemployeraddress: string;
  spfiscalid: string;
  spgender: string;
  spidentitycardid: string;
  spidentitycardtype: string;
  spmaidenname: string;
  spmonthlyincome: number;
  spname: string;
  spotherloan: number;
  spothersexpense: number;
  spothersincome: number;
  spprofession: string;
  spsalutationcode: string;
  spsurname: string;
}

export interface tpSpouseResponse {
  spbirthcity: string;
  spbirthcountry: string;
  spbirthdate: string;
  spemloyertel: string;
  spemployer: string;
  spemployeraddress: string;
  spfiscalid: string;
  spgender: string;
  spidentitycardid: string;
  spidentitycardtype: string;
  spmaidenname: string;
  spmonthlyincome: number;
  spname: string;
  spotherloan: number;
  spothersexpense: number;
  spothersincome: number;
  spprofession: string;
  spsalutationcode: string;
  spsurname: string;
}

export interface tpStatusResponse {
  tpriskstatus: string;
  tpriskstatuslabel: string;
  tpriskstatusdate: string;
  tpsalestatus: string;
  tpsalestatuslabel: string;
  tpsalestatusdate: string;
}

export interface TpAddressResponse2 {
  adrenddate: string;
  adrstartdate: string;
  adrstatus: string;
  adrstatusdate: string;
  adrstatuslabel: string;
  adrtype: string;
  adrtypelabel: string;
  bkbranchename: string;
  tpadrid: number;
  tpid: number;
  tpmainadrcity: string;
  tpmainadrcitylabel: string;
  tpmainadrcountry: string;
  tpmainadrcountrylabel: string;
  tpmainadrregion: string;
  tpmainadrregionlabel: string;
  tpmainadrregionglobale: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
  tpmainadrzipcodelabel: string;
}

export interface TpAddress {
  adrenddate: string;
  adrstartdate: string;
  adrstatus: string;
  adrstatusdate: string;
  adrtype: string;
  tpadrid: number;
  tpid: number;
  tpmainadrcity: string;
  tpmainadrcitylabel:string;
  tpmainadrcountry: string;
  tpmainadrcountrylabel:string;
  tpmainadrregion: string;
  tpmainadrregionglobale: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
}
export interface TpRoleListRequest {
  enddate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tpbkidin: number;
  tpbkidout: number;
  tplateinterestformula: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tproleid: number;
}

export interface TpRoleListResponse {
  enddate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tplateinterestformula: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tproleid: number;
  tpbkidin: number;
  tpbkidout: number;
  bankAccountIn: TpBankAccount;
  bankAccountOut: TpBankAccount;
  address: TpAddress;
}
export interface TpBankAccount {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode: string;
  bktypelabel: string;
  countcode: string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bktype: string;
  currcode: string;
  tpbankname: string;
  tpbic: string;
  tpbkid: number;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
  tpid: number;
}
export interface TpBankAccountResponse2 {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkbranchename: string;
  bkcode: string;
  bkcodename:string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bkstatuslabel: string;
  bktype: string;
  bktypelabel: string;
  countcode: string;
  currcode: string;
  tpbankname: string;
  tpbic: string;
  tpbkid: number;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
  tpid: number;
}
export interface TpstatResponse {
  enddate: string;
  startdate: string;
  status: string;
  statusdate: string;
  statuslabel: string;
  statustype: string;
  statustypelabel?:string;
  taskid: number;
  tpid: number;
  tpstatusid: number;
  userid: number;
  username: string;
}

export interface TpcoressResponse {
  enddate: string;
  startdate: string;
  statusdate: string;
  taskid: number;
  tpcorrespondentid: number;
  tpcorrespondentstatus: string;
  tpcorrespondentstatuslabel: string;
  tpcorrespondenttype: string;
  tpid: number;
  userid: number;
}

export interface Tprelationship {
  creationdate: string;
  enddate: string;
  relcode: string;
  reltype: string;
  relvalue: string;
  startdate: string;
  tpid: number;
  tpidtarget: number;
  tpTargetname: string;
  tpname: string;
  tprelid: number;
  updatedate: string;
  useridcreate: number;
  useridupdate: number;
}

export interface EntityAdditionalAttributeRequest {
  attbooleanvalue: boolean | null;
  attcode: string;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  attdatatype?: any;
  entity: string;
  entityid: number;
  id: number;
}

export interface TpAuthorizationDetailRequest {
  authdetailamount: number;
  authdetailavailableamount: number;
  authdetailbookedamount: number;
  authdetailid: number;
  authdetailusedamount: number;
  authid: number;
  currcode: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;
  tpid: number;
}

export interface TpAuthorizationRequest {
  authDetail: Array<TpAuthorizationDetailRequest>;
  authamount: number;
  authavailableamount: number;
  authbookedamount: number;
  authid: number;
  authstatus: string;
  authstatusdate: string;
  authtype: string;
  authusedamount: number;
  creationdate: string;
  currcode: string;
  enddate: string;
  proctaskid: number;
  startdate: string;
  tpid: number;
  useridcreation: number;
}

export interface TpAuthorizationDetailResponse {
  tpAuthorizationDetailRules:Array<TPAuthorizationDetailRulesResponse>
  authdetailamount: number;
  authdetailavailableamount: number;
  authdetailbookedamount: number;
  authdetailid: number;
  authdetailusedamount: number;
  authid: number;
  currcode: string;
  enddate: string;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofridlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  prcode: string;
  prcodelabel: string;
  startdate: string;
  status: string;
  tpid: number;
  tpname: string;
  tpreference: string;
}

export interface TpAuthorizationResponse {
  authDetail: Array<TpAuthorizationDetailResponse>;
  authamount: number;
  authavailableamount: number;
  authbookedamount: number;
  authid: number;
  authstatus: string;
  authstatusdate: string;
  authstatuslabel: string;
  authtype: string;
  authtypelabel: string;
  authusedamount: number;
  creationdate: string;
  currcode: string;
  enddate: string;
  proctaskid: number;
  startdate: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  useridcreation: number;
}

export interface FindCIPayerParams {
  tpid: number;
  ctrid?: number;
  role?: string;
}

/**
 * @tags Third Party Controller
 * @summary findCIPayer
 */
export function findCIPayer(params: FindCIPayerParams) {
  return request.get<AbstractResponse<unknown, SIPayBeneficiaryResponse>>(
    `${URL_}/v1/${params.tpid}/ci-payers` +
      prepareQueryParams({ ctrid: params?.ctrid, role: params?.role } as any)
  );
}

export interface FindSIBeneficiaryParams {
  tpid: number;
  ctrid?: number;
  role?: string;
}

/**
 * @tags Third Party Controller
 * @summary findSIBeneficiary
 */
export function findSIBeneficiary(params: FindSIBeneficiaryParams) {
  return request.get<AbstractResponse<unknown, SIPayBeneficiaryResponse>>(
    `${URL_}/v1/${params.tpid}/si-beneficiaries` +
      prepareQueryParams({ ctrid: params?.ctrid, role: params?.role } as any)
  );
}

export interface FindByTpReferenceAndTpNameParams {
  role: string;
  tpcardid: string;
  tpfiscalid: string;
  tpname: string;
  tpreference: string;
  tptype: string;
  parentid: number;
}

/**
 * @tags Third Party Controller
 * @summary findByTpReferenceAndTpName
 */
export function findByTpReferenceAndTpName(
  params: FindByTpReferenceAndTpNameParams
) {
  return request.get<AbstractResponse<unknown, TpList>>(
    `${URL_}/v1` +
      prepareQueryParams({
        role: params.role,
        tpcardid: params.tpcardid,
        tpfiscalid: params.tpfiscalid,
        tpname: params.tpname,
        tpreference: params.tpreference,
        parentid: params.parentid,
        tptype: params.tptype,
      } as any)
  );
}

export function findByTpByKeyword(params: FindByTpReferenceAndTpNameParams) {
  return request.get<AbstractResponse<unknown, TpList>>(
    `${URL_}/v1/key-word` +
      prepareQueryParams({
        role: params.role,
        tpcardid: params.tpcardid,
        tpfiscalid: params.tpfiscalid,
        tpname: params.tpname,
        tpreference: params.tpreference,
      } as any)
  );
}

export interface CreateThirdPartyParams {
  ThirdPartyRequest: ThirdPartyRequest;
}

/**
 * @tags Third Party Controller
 * @summary createThirdParty
 */
export function createThirdParty(params: CreateThirdPartyParams) {
  return request.post<AbstractResponse<ThirdPartyResponse, unknown>>(
    `${URL_}/v1`,
    params.ThirdPartyRequest
  );
}

export interface UpdateTPAddressParams {
  ThirdPartyRequest: ThirdPartyRequest;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateTPAddress
 */
export function updateTPAddress(params: UpdateTPAddressParams) {
  return request.put<AbstractResponse<ThirdPartyResponse, unknown>>(
    `${URL_}/v1/${params.tpid}/addresses`,
    params.ThirdPartyRequest
  );
}

export interface GetThirdPartyByIdParams {
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyById
 */
export function getThirdPartyById(params: GetThirdPartyByIdParams) {
  return request.get<AbstractResponse<ThirdPartyResponse, unknown>>(
    `${URL_}/v1/${params.tpid}`
  );
}

export interface UpdateThirdPartyParams {
  ThirdPartyRequest: ThirdPartyRequest;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdParty
 */
export function updateThirdParty(params: UpdateThirdPartyParams) {
  return request.put<AbstractResponse<ThirdPartyResponse, unknown>>(
    `${URL_}/v1/${params.tpid}`,
    params.ThirdPartyRequest
  );
}


export interface GetThirdPartyAddresListByTpidParams {
  tpid: number;
}
/**
 * @tags Third Party Controller
 * @summary getThirdPartyAddresListByTpid
 */
export function getThirdPartyAddresListByTpid(
  params: GetThirdPartyAddresListByTpidParams
) {
  return request.get<AbstractResponse<object, TpAddressResponse2>>(
    `${URL_}/v1/${params.tpid}/addresses`
  );
}

export interface CreateThirdPartyAddressParams {
  tpAddressRequest: TpAddress;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary createThirdPartyAddress
 */
export function createThirdPartyAddress(params: CreateThirdPartyAddressParams) {
  return request.post<AbstractResponse<TpAddress, object>>(
    `${URL_}/v1/${params.tpid}/addresses`,
    params.tpAddressRequest
  );
}

export interface GetThirdPartyAddresByIdParams {
  tpadrid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyAddresById
 */
export function getThirdPartyAddresById(params: GetThirdPartyAddresByIdParams) {
  return request.get<AbstractResponse<TpAddress, object>>(
    `${URL_}/v1/${params.tpid}/addresses/${params.tpadrid}`
  );
}

export interface UpdateThirdPartyAddresParams {
  tpAddressRequest: TpAddress;
  tpadrid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyAddres
 */
export function updateThirdPartyAddres(params: UpdateThirdPartyAddresParams) {
  return request.put<AbstractResponse<TpAddress, object>>(
    `${URL_}/v1/${params.tpid}/addresses/${params.tpadrid}`,
    params.tpAddressRequest
  );
}

export interface DeleteThirdPartyAddressParams {
  tpadrid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary deleteThirdPartyAddress
 */
export function deleteThirdPartyAddress(params: DeleteThirdPartyAddressParams) {
  return request.delete<AbstractResponse<TpAddress, object>>(
    `${URL_}/v1/${params.tpid}/addresses/${params.tpadrid}`
  );
}

export interface UpdateThirdPartyAddresStatusParams {
  adrstatus: string;
  tpadrid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyAddresStatus
 */
export function updateThirdPartyAddresStatus(
  params: UpdateThirdPartyAddresStatusParams
) {
  return request.put<AbstractResponse<TpAddress, object>>(
    `${URL_}/v1/${params.tpid}/addresses/${params.tpadrid}/status/${params.adrstatus}`
  );
}

export interface GetThirdPartyRoleListByTpidParams {
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyRoleListByTpid
 */
export function getThirdPartyRoleListByTpid(
  params: GetThirdPartyRoleListByTpidParams
) {
  return request.get<AbstractResponse<object, TpRoleListResponse>>(
    `${URL_}/v1/${params.tpid}/roles`
  );
}
export interface CreateThirdPartyRoleParams {
  tpid: number;
  tproleRequest: TpRoleListRequest;
}

/**
 * @tags Third Party Controller
 * @summary createThirdPartyRole
 */
export function createThirdPartyRole(params: CreateThirdPartyRoleParams) {
  return request.post<AbstractResponse<TpRoleListRequest, object>>(
    `${URL_}/v1/${params.tpid}/roles`,
    params.tproleRequest
  );
}
export interface GetThirdPartyRoleByidParams {
  tpid: number;
  tproleid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyRoleByid
 */
export function getThirdPartyRoleByid(params: GetThirdPartyRoleByidParams) {
  return request.get<AbstractResponse<TpRoleListResponse, object>>(
    `${URL_}/v1/${params.tpid}/roles/${params.tproleid}`
  );
}

export interface UpdateThirdPartyRoleParams {
  tpid: number;
  tproleRequest: TpRoleListRequest;
  tproleid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyRole
 */
export function updateThirdPartyRole(params: UpdateThirdPartyRoleParams) {
  return request.put<AbstractResponse<TpRoleListRequest, object>>(
    `${URL_}/v1/${params.tpid}/roles/${params.tproleid}`,
    params.tproleRequest
  );
}

export interface DeleteThirdPartyRoleByidParams {
  tpid: number;
  tproleid: number;
}

/**
 * @tags Third Party Controller
 * @summary deleteThirdPartyRoleByid
 */
export function deleteThirdPartyRoleByid(
  params: DeleteThirdPartyRoleByidParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL_}/v1/${params.tpid}/roles/${params.tproleid}`
  );
}
export interface UpdateThirdPartyRoleStatusParams {
  status: string;
  tpid: number;
  tproleid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyRoleStatus
 */
export function updateThirdPartyRoleStatus(
  params: UpdateThirdPartyRoleStatusParams
) {
  return request.put<AbstractResponse<TpRoleListResponse, object>>(
    `${URL_}/v1/${params.tpid}/roles/${params.tproleid}/status/${params.status}`
  );
}
export interface GetThirdPartyBkAccountListByTpidParams {
  tpid: number;
}
/**
 * @tags Third Party Controller
 * @summary getThirdPartyBkAccountListByTpid
 */
export function getThirdPartyBkAccountListByTpid(
  params: GetThirdPartyBkAccountListByTpidParams
) {
  return request.get<AbstractResponse<object, TpBankAccountResponse2>>(
    `${URL_}/v1/${params.tpid}/bank-accounts`
  );
}

export interface CreateThirdPartyBkAccountParams {
  bkrequest: TpBankAccount;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary createThirdPartyBkAccount
 */
export function createThirdPartyBkAccount(
  params: CreateThirdPartyBkAccountParams
) {
  return request.post<AbstractResponse<TpBankAccount, object>>(
    `${URL_}/v1/${params.tpid}/bank-accounts`,
    params.bkrequest
  );
}

export interface GetThirdPartyBkAccountByIdParams {
  tpbkid: number;
  tpid: number;
}
/**
 * @tags Third Party Controller
 * @summary getThirdPartyBkAccountById
 */
export function getThirdPartyBkAccountById(
  params: GetThirdPartyBkAccountByIdParams
) {
  return request.get<AbstractResponse<TpBankAccount, object>>(
    `${URL_}/v1/${params.tpid}/bank-accounts/${params.tpbkid}`
  );
}

export interface UpdateThirdPartyBkAccountParams {
  bkrequest: TpBankAccount;
  tpbkid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyBkAccount
 */
export function updateThirdPartyBkAccount(
  params: UpdateThirdPartyBkAccountParams
) {
  return request.put<AbstractResponse<TpBankAccount, object>>(
    `${URL_}/v1/${params.tpid}/bank-accounts/${params.tpbkid}`,
    params.bkrequest
  );
}
export interface DeleteThirdPartyBkAccountParams {
  tpbkid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary deleteThirdPartyBkAccount
 */
export function deleteThirdPartyBkAccount(
  params: DeleteThirdPartyBkAccountParams
) {
  return request.delete<AbstractResponse<TpBankAccount, object>>(
    `${URL_}/v1/${params.tpid}/bank-accounts/${params.tpbkid}`
  );
}
export interface UpdateThirdPartyBkAccountStatusParams {
  bkstatus: string;
  tpbkid: number;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyBkAccountStatus
 */
export function updateThirdPartyBkAccountStatus(
  params: UpdateThirdPartyBkAccountStatusParams
) {
  return request.put<AbstractResponse<TpBankAccount, object>>(
    `${URL_}/v1/${params.tpid}/bank-accounts/${params.tpbkid}/status/${params.bkstatus}`
  );
}
export interface GetTPCurrentStatusByTpidParams {
  tpid: number;
type: string;
};


/**
 * @tags Third Party Controller
 * @summary getTPCurrentStatusByTpid
 */
export function getTPCurrentStatusByTpid (params: GetTPCurrentStatusByTpidParams) {
  return request.get<AbstractResponse<object,TpstatResponse>>(`${URL_}/v1/${params.tpid}/status/current` + prepareQueryParams({type: params.type} as any))
};

export interface GetTPStatusByTpidParams {
  tpid: number;
  type: string;
}

/**
 * @tags Third Party Controller
 * @summary getTPStatusByTpid
 */
export function getTPStatusByTpid(params: GetTPStatusByTpidParams) {
  return request.get<AbstractResponse<object, TpstatResponse>>(
    `${URL_}/v1/${params.tpid}/status` +
      prepareQueryParams({ type: params.type } as any)
  );
}

export interface GetTpcorrespondentByTpidParams {
  tpid: number;
  type: string;
}

/**
 * @tags Third Party Controller
 * @summary getTpcorrespondentByTpid
 */
export function getTpcorrespondentByTpid(
  params: GetTpcorrespondentByTpidParams
) {
  return request.get<AbstractResponse<object, TpcoressResponse>>(
    `${URL_}/v1/${params.tpid}/correspondents` +
      prepareQueryParams({ type: params.type } as any)
  );
}

export interface GetThirdPartyRelationListByTpidParams {
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyRelationListByTpid
 */
export function getThirdPartyRelationListByTpid(
  params: GetThirdPartyRelationListByTpidParams
) {
  return request.get<AbstractResponse<object, Tprelationship>>(
    `${URL_}/v1/${params.tpid}/relationships`
  );
}
export interface AddThirdPartyReltionParams {
  request: Tprelationship;
}

/**
 * @tags Third Party Controller
 * @summary addThirdPartyReltion
 */
export function addThirdPartyReltion(params: AddThirdPartyReltionParams) {
  return request.post<AbstractResponse<Tprelationship, object>>(
    `${URL_}/v1/relationships`,
    params.request
  );
}

export interface UpdateThirdPartyReltionParams {
  request: Tprelationship;
  tprelid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyReltion
 */
export function updateThirdPartyReltion(params: UpdateThirdPartyReltionParams) {
  return request.put<AbstractResponse<Tprelationship, object>>(
    `${URL_}/v1/relationships/${params.tprelid}`,
    params.request
  );
}

export interface DeleteThirdPartyReltionParams {
  tprelid: number;
}

/**
 * @tags Third Party Controller
 * @summary deleteThirdPartyReltion
 */
export function deleteThirdPartyReltion(params: DeleteThirdPartyReltionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL_}/v1/relationships/${params.tprelid}`
  );
}

export interface GetEntityDataByidParams {
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getEntityDataByid
 */
export function getEntityDataByid(params: GetEntityDataByidParams) {
  return request.get<AbstractResponse<EntityDataResponse, object>>(
    `${URL_}/v1/${params.tpid}//entity-data`
  );
}

export interface EntityDataResponse {
  id: number;
  label: string;
  reference: string;
  type: string;
}

export interface GetThirdPartyAuthorizationListByTpidParams {
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary getThirdPartyAuthorizationListByTpid
 */
export function getThirdPartyAuthorizationListByTpid(
  params: GetThirdPartyAuthorizationListByTpidParams
) {
  return request.get<AbstractResponse<object, TpAuthorizationResponse>>(
    `${URL_}/v1/${params.tpid}/authorizations`
  );
}

export interface UpdateThirdPartyAuthorizationStatusParams {
  authid: number;
  status: string;
  tpid: number;
}

/**
 * @tags Third Party Controller
 * @summary updateThirdPartyAuthorizationStatus
 */
export function updateThirdPartyAuthorizationStatus(
  params: UpdateThirdPartyAuthorizationStatusParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL_}/v1/${params.tpid}/authorizations/${params.authid}/status/${params.status}`
  );
}

export interface GetEntityAdditionaAttributesParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel?: string;
  entity: string;
  entityid: number;
  entitytype: string;
  prcode: string;
}

/**
 * @tags Third Party Controller
 * @summary getEntityAdditionaAttributes
 */
export function getThirdPartyAdditionalAttributes(
  params: GetEntityAdditionaAttributesParams
) {
  return request.get<AbstractResponse<object, ViewEntityAddAttributeResponse>>(
    `${URL_}/v1/additional-attributes` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params?.assetmodel,
        entity: params.entity,
        entityid: params.entityid,
        entitytype: params.entitytype,
        prcode: params.prcode,
      } as any)
  );
}

export interface GetRulesByAuthdetaiIDParams {
  authdetailid: number;
}

export function getRulesByAuthdetaiID(params: GetRulesByAuthdetaiIDParams) {
  return request.get<AbstractResponse<object, TPAuthorizationDetailRulesResponse>>(
    `${URL_}/v1/authorization-details/${params.authdetailid}`);
}

export interface CreateTPAuthorizationDetailRulesParams {
  request: TPAuthorizationDetailRulesRequest;
}

export function createTPAuthorizationDetailRules (params: CreateTPAuthorizationDetailRulesParams) {
  return request.post<AbstractResponse<object,object>>(`${URL_}/v1/authorization-rules`, params.request)
}

export interface RemoveTPAuthorizationDetailRulesParams{
  rulid: number;
}

export function removeTPAuthorizationDetailRules(params: RemoveTPAuthorizationDetailRulesParams) {
  return request.delete<AbstractResponse<object,object>>(`${URL_}/v1/authorization-rules/${params.rulid}`)
}
